/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-10-12 16:09:36
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-08-22 17:53:10
 */
import request from '@/utils/request'

interface UploadParams {
  files: any // 文件内容
  upload_path?: string // 文件路径, 默认为：default
  business_type?: string // 文件使用场景（1：导入项目，2：项目附件，3：评论附件，4：图片） 默认为4
}

interface DownloadParams {
  file_id: string // 文件id
}

// 文件上传(通用接口)
export async function fileUpload(params: UploadParams) {
  return request('/api/v2/file/upload', {
    method: 'POST',
    data: params
  })
}

// 文件查看(通用接口)
export async function fileDownload(params: DownloadParams) {
  return request('/api/v2/file/download_file', {
    method: 'GET',
    data: params
  })
}
export async function getFileDownloadUrl(params: DownloadParams) {
  return request('/api/v2/file/get_download_url', {
    method: 'GET',
    data: params
  })
}

export async function getFileDownloadBlob(url: string) {
  // 保留签名下载地址，避免 request 拦截器追加参数和请求头。
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`附件下载失败：${response.status}`)
  }
  return response.blob()
}

// V1.8.2 WPS预览文件增加登录态判断
// 文件预览
export async function filePreview(params: any) {
  return request('/api/v2/file/preview_file', {
    method: 'POST',
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json'
    },
    hideError: true
  })
}

interface IGlobalSearchRequest {
  offset: number
  limit: number
  keywords: string
  index_type: number
}
// 全局搜索接口
export async function globalSearch(params?: IGlobalSearchRequest) {
  return request('/api/v2/system/search/do', {
    method: 'GET',
    data: params
  })
}
